module.exports = __webpack_public_path__ + "media/src/images/icons/add-0fbb71d308cebaba19e675502bde12e7.svg";